import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_WORKSPACE_AMAZON } from './api/query'
import { Data, Variables } from './api/types'
import { Props, UseGetWorkspaceAmazon, WorkspaceAmazonSlice } from './types'

export const useGetWorkspaceAmazon = ({ workspaceId }: Props): UseGetWorkspaceAmazon => {
  const { data, isLoading } = useQuery<Variables, Data, null | WorkspaceAmazonSlice>({
    options: {
      enabled: workspaceId !== undefined,
      select: ({ workspaceAmazon }: Data): null | WorkspaceAmazonSlice =>
        workspaceAmazon ? fromDTO(workspaceAmazon) : null,
    },
    query: GET_WORKSPACE_AMAZON,
    variables: { workspaceId },
  })

  return {
    loading: isLoading,
    workspaceAmazon: data,
  }
}
